import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const BusinessCapitalConsulting = () => {
  return (
    <>
      <Helmet>
        <title>Business Capital Consulting - Miranda Landa Services LLC</title>
        <meta name="description" content="Expert business capital consulting services. We help you understand funding options and prepare for success. We are consultants, not lenders." />
      </Helmet>

      {/* Hero with Image */}
      <section style={{
        position: 'relative',
        minHeight: '400px',
        display: 'flex',
        alignItems: 'center',
        color: 'white',
        padding: '4rem 2rem',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1920&h=600&fit=crop&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.4)'
        }} />
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(5, 150, 105, 0.9) 0%, rgba(16, 185, 129, 0.8) 100%)'
        }} />
        <div style={{position: 'relative', zIndex: 1, maxWidth: '1100px', margin: '0 auto', width: '100%'}}>
          <div style={{marginBottom: '1rem'}}>
            <Link to="/services" style={{color: 'white', opacity: 0.9}}>← Back to Services</Link>
          </div>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1rem'}}>
            💡 Business Capital Consulting
          </h1>
          <p style={{fontSize: '1.3rem', opacity: 0.95, maxWidth: '700px'}}>
            Expert advisory services to help you understand and navigate business funding options
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          
          {/* Important Notice */}
          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            marginBottom: '3rem',
            textAlign: 'center'
          }}>
            <p style={{color: '#92400e', fontWeight: '700', fontSize: '1.1rem', margin: 0}}>
              ⚠️ We are a CONSULTING FIRM — We do NOT issue loans or make lending decisions
            </p>
          </div>

          <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '3rem', marginBottom: '4rem'}}>
            <div>
              <h2 style={{fontSize: '2rem', fontWeight: '700', color: '#064e3b', marginBottom: '1.5rem'}}>
                What is Business Capital Consulting?
              </h2>
              <p style={{fontSize: '1.1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                Business capital consulting is professional advisory service that helps business owners understand their 
                funding options, assess their readiness, and prepare comprehensive documentation for funding opportunities.
              </p>
              <p style={{fontSize: '1.1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                As consultants, we guide you through the complex landscape of business financing, helping you make informed 
                decisions about which funding paths align with your business goals.
              </p>
              
              <img 
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=500&fit=crop&q=80"
                alt="Business consultation meeting"
                style={{width: '100%', height: '400px', objectFit: 'cover', borderRadius: '12px', marginBottom: '2rem'}}
              />
            </div>

            <div>
              <div className="card" style={{position: 'sticky', top: '100px'}}>
                <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#064e3b', marginBottom: '1.5rem'}}>
                  Ready to Get Started?
                </h3>
                <p style={{color: '#6b7280', marginBottom: '1.5rem'}}>
                  Schedule a free consultation to discuss your business funding needs
                </p>
                <Link to="/contact" style={{
                  background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                  color: 'white',
                  padding: '1rem 2rem',
                  borderRadius: '50px',
                  fontWeight: '700',
                  fontSize: '1.1rem',
                  display: 'block',
                  textAlign: 'center',
                  marginBottom: '1rem'
                }}>
                  Schedule Consultation
                </Link>
                <p style={{fontSize: '0.9rem', color: '#6b7280', textAlign: 'center'}}>
                  ✓ Free initial consultation<br/>
                  ✓ No obligation<br/>
                  ✓ Confidential discussion
                </p>
              </div>
            </div>
          </div>

          {/* What's Included */}
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2rem', fontWeight: '700', color: '#064e3b', marginBottom: '2rem', textAlign: 'center'}}>
              What's Included in Our Consulting Service
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '2rem'
            }}>
              {[
                { icon: '🎯', title: 'Funding Needs Assessment', desc: 'Comprehensive evaluation of your capital requirements' },
                { icon: '📊', title: 'Capital Structure Analysis', desc: 'Review of your current financial position and capacity' },
                { icon: '💡', title: 'Financing Strategy Development', desc: 'Customized roadmap for your funding journey' },
                { icon: '⚖️', title: 'Risk Evaluation', desc: 'Assessment of potential risks and mitigation strategies' },
                { icon: '📋', title: 'Documentation Guidance', desc: 'Help preparing required financial documents' },
                { icon: '🤝', title: 'Lender Matching', desc: 'Connect with appropriate financial institutions' }
              ].map((item, index) => (
                <div key={index} style={{
                  background: '#f0fdf4',
                  padding: '2rem',
                  borderRadius: '12px',
                  textAlign: 'center'
                }}>
                  <div style={{fontSize: '3rem', marginBottom: '1rem'}}>{item.icon}</div>
                  <h3 style={{fontSize: '1.2rem', fontWeight: '700', color: '#064e3b', marginBottom: '0.75rem'}}>
                    {item.title}
                  </h3>
                  <p style={{color: '#065f46', fontSize: '0.95rem'}}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Process */}
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2rem', fontWeight: '700', color: '#064e3b', marginBottom: '2rem', textAlign: 'center'}}>
              Our Consultation Process
            </h2>
            <div style={{display: 'grid', gap: '1.5rem'}}>
              {[
                { step: '1', title: 'Initial Discovery', desc: 'We learn about your business, goals, and funding needs' },
                { step: '2', title: 'Financial Review', desc: 'Comprehensive assessment of your current financial position' },
                { step: '3', title: 'Strategy Development', desc: 'Create a customized funding preparation strategy' },
                { step: '4', title: 'Documentation Support', desc: 'Guide you in preparing all necessary documents' },
                { step: '5', title: 'Lender Connection', desc: 'Introduce you to appropriate financial institutions' },
                { step: '6', title: 'Ongoing Guidance', desc: 'Continued support throughout your funding journey' }
              ].map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  gap: '2rem',
                  alignItems: 'flex-start',
                  background: '#f9fafb',
                  padding: '2rem',
                  borderRadius: '12px'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                    color: 'white',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem',
                    fontWeight: '800',
                    flexShrink: 0
                  }}>
                    {item.step}
                  </div>
                  <div>
                    <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#064e3b', marginBottom: '0.5rem'}}>
                      {item.title}
                    </h3>
                    <p style={{color: '#6b7280'}}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div style={{
            background: 'linear-gradient(135deg, #064e3b 0%, #059669 100%)',
            color: 'white',
            padding: '4rem 2rem',
            borderRadius: '16px',
            textAlign: 'center'
          }}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1.5rem'}}>
              Ready to Explore Your Funding Options?
            </h2>
            <p style={{fontSize: '1.2rem', marginBottom: '2.5rem', opacity: 0.95}}>
              Let our expert consultants guide you through the business capital preparation process
            </p>
            <Link to="/contact" style={{
              background: 'white',
              color: '#059669',
              padding: '1.25rem 3rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.2rem',
              display: 'inline-block'
            }}>
              Schedule Your Free Consultation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessCapitalConsulting;
